export const NETWORK_COMMISSION_AMOUNT_BTC = 0.0001;
